import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "bedFormIsOpen", false);
        Vue.set(state, "bedGridIsOpen", true);
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
    },

    setBedFormOpen(state) {
        state.bedFormIsOpen = true;
        state.bedGridIsOpen = false;
    },
    setBedFormClose(state) {
        state.bedFormIsOpen = false;
        state.bedGridIsOpen = true;
    }
}
